module.exports = __webpack_public_path__ + "static/media/cover.495aa06.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/articles/2/cover.webm
// module id = jBHb
// module chunks = 0